var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      key: _vm.id,
      ref: "details",
      class: {
        [_vm.positionX]: true,
        [_vm.positionY]: true,
        componentSelect: true,
        show: _vm.detailsState,
      },
    },
    [
      _c("summary", { on: { click: _vm.toggleDetails } }, [
        _c("p", [_vm._v(_vm._s(_vm.data[_vm.valueSelect] || ""))]),
        _c("i", { staticClass: "fa-solid fa-caret-down" }),
      ]),
      _c(
        "ul",
        { ref: "listOptions", staticClass: "listOptions" },
        _vm._l(Object.keys(_vm.data), function (keyData) {
          return _c("li", { key: keyData }, [
            _c("label", [
              _c("input", {
                attrs: { type: "radio" },
                domProps: {
                  value: keyData,
                  checked: keyData === _vm.valueSelect,
                },
                on: { change: _vm.handleChange },
              }),
              _c("span", [_vm._v(_vm._s(_vm.data[keyData]))]),
            ]),
          ])
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }